fragment CategoryFragment on Category {
    id
    slug
    path
    parent_id
    parent {
        id
        slug
        path
        name
        description
        image_id
        image {
            ...MediaFragment
        }
        ancestors {
            id
            slug
            path
            parent_id
            name
            description
            image_id
            image {
                ...MediaFragment
            }
        }
        trail
    }
    name
    description
    image_id
    image {
        ...MediaFragment
    }
    ancestors {
        id
        slug
        path
        parent_id
        name
        description
        image_id
        image {
            ...MediaFragment
        }
    }
    trail
}